import React from "react";
import { IMAGE_BASE_URL } from '../../common/Constants';
import moment from "moment";


const FlooringRateCard = ({ flooringRates, activeTab }) => {
  console.log("PROPs", IMAGE_BASE_URL);
  return (
    <section className="flooring-full-card-section">
      {flooringRates &&
        flooringRates.map((item, index) => (
          <div className="flooring-full-card" key={index}>
            <div className="full-card-header">
              <div className="logo-block">
                <img

                  src={`${IMAGE_BASE_URL}${item?.icon}`}
                  alt=""
                />
              </div>
              <div className="last-updated">
                <p>Last Updated : {item?.updated_at}</p>
              </div>
              <div className="card-header-group">
                <div className="card-header-block">
                  <div className="header-block-list">
                    <h2>{item.name}</h2>
                    <div className="inline-flex">
                      {item.hasPremium == 1 ? (
                        <span className="category-list">
                          <img
                            src="/images/prem_icon.svg"
                            className="w-[16px]"
                            alt="star"
                          />
                          <span className="relative top-[1px]">Premium</span>
                        </span>
                      ) : null}
                      {item.featured == 1 ? (
                        <span className="category-list">
                          <img
                            src="/images/star.svg"
                            className="w-[16px]"
                            alt="star"
                          />
                          <span className="relative top-[1px]">Featured</span>
                        </span>
                      ) : null}
                    </div>
                  </div>
                  <div className="header-block-list">
                    <p className="text-[12px] mb-[0] flex items-center">
                      <img
                        src="/images/fi_clock.svg"
                        alt="calendar"
                        className="mr-[5px]"
                      />
                      Approval Time:{" "}
                      <strong className="ml-[5px] font-[600]">
                        {item?.approvalTime}
                      </strong>
                    </p>
                    <p className="text-[12px] mb-[0] flex items-center">
                      <img
                        src="/images/fi_zap.svg"
                        alt="calendar"
                        className="mr-[5px]"
                      />
                      Loan to Value:
                      <strong className="ml-[5px] font-[600]">
                        {item?.ltv}
                      </strong>
                    </p>
                  </div>
                </div>
                <div className="card-header-info">
                  <div className="info-header-block-list">
                    <h3>
                      Contact No: <span>{item.phoneNumber}</span>
                    </h3>
                    <h4>
                      Email: <span>{item.email}</span>
                    </h4>
                  </div>
                  <div className="info-header-block-list">
                    <h3>
                      Address:{" "}
                      <span>
                        {item?.addressLine1}, {item?.addressLine2}{" "}
                        {item?.postalCode}
                      </span>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
            <div className="vehicle-types-group">
              {item?.products &&
                item?.products?.length > 0 &&
                item?.products.map((vehicleType, idx) => (
                  <div className="vehicle-types-list" key={idx}>
                    <h2>{vehicleType.name}</h2>
                    {activeTab == 2 && (
                      <h3>
                        Scheduled For:{" "}
                        <span>{vehicleType?.scheduled_date_time}</span>
                      </h3>
                    )}
                    <h3>
                      Flooring Int. (30 days):{" "}
                      <span>
                        {vehicleType?.interest_from.slice(
                          0,
                          vehicleType?.interest_from.indexOf(".") + 2
                        )}{" "}
                        % -{" "}
                        {vehicleType?.interest_to.slice(
                          0,
                          vehicleType?.interest_to.indexOf(".") + 2
                        )}{" "}
                        %
                      </span>
                    </h3>
                    <h4>
                      Admin Fee:{" "}
                      <span>
                        ${vehicleType.admin_fee_from.slice(
                          0,
                          vehicleType.admin_fee_from.indexOf(".")
                        )} - $
                        {vehicleType?.admin_fee_to.slice(
                          0,
                          vehicleType?.admin_fee_to.indexOf(".")
                        )}
                      </span>
                    </h4>
                  </div>
                ))}
            </div>
          </div>
        ))
      }
    </section >
  );
};

export default FlooringRateCard;
